@if (!isPrinting) {
  <zbp-data-table
    [rows]="rows"
    [columns]="columns"
    [colorPrint]="true"
  />
} @else {
  @for (columnForPrint of columnsForPrint; track $index) {
    <div class="break-after-page">
      <zbp-data-table
        [rows]="rowsForPrinting[$index]"
        [columns]="columnForPrint"
        [colorPrint]="true"
        [printableHeaders]="printableReportHeadings"
      />
    </div>
  }
}
